module.exports = __webpack_public_path__ + "static/assets/1dc09fd01839126e8086ff1ba26cf9f1.png";